import { useCallback, useMemo } from 'react';

import { useStateSelector } from './use-state-selector';

export const usePipingAnswersReplacer = () => {
    const answers = useStateSelector((s) => s.questionAnswers);
    const linkParamsRaw = useStateSelector((s) => s.linkParams);
    const queryParams = useStateSelector((s) => s.queryParams);
    const linkParams = useMemo(() => ({ ...queryParams, ...linkParamsRaw }), [linkParamsRaw, queryParams]);

    return useCallback(
        (text: string) => {
            if (typeof text !== 'string') return text;

            // Циклические подстановки ({Q-1} -> {Q-2} -> {Q-1}) зацикливали while
            // (FRONT-2A9A: too much recursion) — ограничиваем число проходов.
            const MAX_PIPING_PASSES = 10;
            let passes = 0;

            while (passes < MAX_PIPING_PASSES && text.match(/\{Q\-([^}]+)\}/gi)) {
                passes += 1;
                text = text.replace(/\{Q\-([^}]+)\}/gi, (_, key) => answers[key] || '');
            }
            return text.replace(/\{LP\-([^}]+)\}/gi, (_, key) => linkParams[key] || '');
        },
        [answers, linkParams],
    );
};
